import { PhysicsLayers } from '@features/InstrumentForge/types/instrumentForge.types';

/**
 * Formats a blended InstrumentForge profile's physics layers into the
 * {LAYER-2..5} tagged text block used across every Studio Team invocation
 * path. Framework-free — no React/browser dependency — so it's imported
 * both by ProductionConfigContext (client) and the server-side executors
 * (Album Mode, Bulk Runs) that need the same text without a live context.
 */
export function formatInstrumentForgePhysics(physicsLayers: PhysicsLayers): string {
  const parts: string[] = [];

  // Layer 2: Rhythm Section
  parts.push(physicsLayers.layer2.header);
  parts.push(physicsLayers.layer2.drumBehavior);
  parts.push(physicsLayers.layer2.drumChain);
  parts.push(physicsLayers.layer2.bassBehavior);
  parts.push(physicsLayers.layer2.bassChain);
  parts.push('');

  // Layer 3: Guitars
  parts.push(physicsLayers.layer3.header);
  parts.push(physicsLayers.layer3.guitarBehavior);
  parts.push(physicsLayers.layer3.rhythmLChain);
  parts.push(physicsLayers.layer3.rhythmRChain);
  if (physicsLayers.layer3.leadChain) parts.push(physicsLayers.layer3.leadChain);
  if (physicsLayers.layer3.textureChain) parts.push(physicsLayers.layer3.textureChain);

  // Layer 4: Atmosphere (if present)
  if (physicsLayers.layer4) {
    parts.push('');
    parts.push(physicsLayers.layer4.header);
    parts.push(physicsLayers.layer4.keysBehavior);
    parts.push(physicsLayers.layer4.keysChain);
  }

  // Layer 5: Specialty (if present)
  if (physicsLayers.layer5) {
    parts.push('');
    parts.push(physicsLayers.layer5.header);
    parts.push(physicsLayers.layer5.instrumentBehavior);
    parts.push(physicsLayers.layer5.instrumentChain);
  }

  return parts.join('\n');
}
